import { render, staticRenderFns } from "./Bdr2026NestedRecords.vue?vue&type=template&id=025038ba&"
import script from "./Bdr2026NestedRecords.vue?vue&type=script&lang=js&"
export * from "./Bdr2026NestedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports